<template>
    <div class="services-area pb-70">
        <div class="container">
            <div class="section-title">
                <span class="top-title">Service</span>
                <h2>Commercial Disinfection Services</h2>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime vero reprehenderit vel accusantium, facilis architecto consectetur nobis tempore ullam suscipit tenetur mollitia corporis veritatis.</p>
            </div>

            <div class="row">
                <div class="col-lg-4 col-sm-6">
                    <div class="single-services">
                        <img src="../../assets/images/services/services-1.jpg" alt="Image">

                        <div class="services-content">
                            <h3>House Cleaning</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolor sit amet, consectetur.</p>
                            
                            <router-link to="/services-details" class="read-more">
                                Read More
                                <i class="bx bx-plus"></i>
                            </router-link>

                            <span class="flaticon-couch"></span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6">
                    <div class="single-services">
                        <img src="../../assets/images/services/services-2.jpg" alt="Image">

                        <div class="services-content">
                            <h3>Window  Cleaning</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolor sit amet, consectetur.</p>

                            <router-link to="/services-details" class="read-more">
                                Read More
                                <i class="bx bx-plus"></i>
                            </router-link>

                            <span class="flaticon-windows"></span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0">
                    <div class="single-services">
                        <img src="../../assets/images/services/services-3.jpg" alt="Image">

                        <div class="services-content">
                            <h3>Apartment Cleaning</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt dolor sit amet, consectetur.</p>

                            <router-link to="/services-details" class="read-more">
                                Read More
                                <i class="bx bx-plus"></i>
                            </router-link>

                            <span class="flaticon-house"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CommercialDisinfectionServices'
}
</script>